
    var content = require("!!../../../node_modules/css-loader/index.js??ref--7-1!../../../node_modules/sass-loader/lib/loader.js!./MigrationTakeover.scss");
    var insertCss = require("!../../lib/isomorphic-style-loader/insertCss.js");

    if (typeof content === 'string') {
      content = [[module.id, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };

    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (module.hot && typeof window !== 'undefined' && window.document) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--7-1!../../../node_modules/sass-loader/lib/loader.js!./MigrationTakeover.scss", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--7-1!../../../node_modules/sass-loader/lib/loader.js!./MigrationTakeover.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  